import { DownloadItemType } from "../../types";
import { postFileRequestWrapper } from "../../utilities";

export type createBetaResponse = DownloadItemType;

type createBetaBody = {
  version_number: string;
  display_name: string | null;
  store_id: string;
  app_id: string;
};

export function createBeta(
  body: createBetaBody,
  file: File
): Promise<createBetaResponse> {
  return postFileRequestWrapper<createBetaBody, createBetaResponse>({
    url: `${ENV_SETTINGS.API_URL}/betas`,
    body,
    file,
  });
}
